// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { api } from '../services/api';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import './Header.css';

const getTitleMap = (t) => ({
  '/app/admin': t('nav.dashboard'),
  '/app/collection': t('nav.collection'),
  '/app/supply': t('nav.supplyDemand'),
  '/app/logs': t('nav.log'),
  '/app/data': t('nav.data'),
  '/app/config': t('nav.config'),
  '/app/assets': t('nav.assets'),
  '/app/operations': t('nav.operations'),
  '/app/alerts': t('nav.alerts'),
  '/app/user': t('nav.user')
});

const Header = ({ onToggleSidebar }) => {
  const { t } = useTranslation();
  const [currentTime, setCurrentTime] = useState(new Date());
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState({ name: t('header.defaultUser'), isadmin: 0 });
  const [loginIp, setLoginIp] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem('currentUser');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setUser(parsed);
      } catch (e) {}
    }
    const savedIp = localStorage.getItem('loginIp');
    if (savedIp) {
      setLoginIp(savedIp);
    }
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    const weeks = [t('admin.sunday'), t('admin.monday'), t('admin.tuesday'), t('admin.wednesday'), t('admin.thursday'), t('admin.friday'), t('admin.saturday')];
    const y = date.getFullYear();
    const mo = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    const s = String(date.getSeconds()).padStart(2, '0');
    return `${y}-${mo}-${d} ${h}:${mi}:${s} ${weeks[date.getDay()]}`;
  };

  const handleLogout = async () => {
    try {
      const saved = localStorage.getItem('currentUser');
      if (saved) {
        const { id, name } = JSON.parse(saved);
        await api.logout({ userId: id, username: name });
      }
    } catch (e) {}
    localStorage.removeItem('currentUser');
    localStorage.removeItem('sessionToken');
    localStorage.removeItem('loginIp');
    navigate('/');
  };

  const pageTitle = getTitleMap(t)[location.pathname] || t('nav.dashboard');

  return (
    <div className="app-header">
      <div className="header-left">
        <button className="hamburger-btn" onClick={onToggleSidebar}>
          <MenuOutlined />
        </button>
        <div className="header-title-bar">
          <h2 className="header-title">{pageTitle}</h2>
        </div>
        <div className="time-location">
          <span className="time">{formatDate(currentTime)}</span>
          <span className="location">{user.location || t('header.location')}</span>
        </div>
      </div>
      <div className="header-right">
        <Select value={i18n.language} onChange={lang => i18n.changeLanguage(lang)} style={{ width: 100, marginRight: 12 }}>
          <Select.Option value="zh">中文</Select.Option>
          <Select.Option value="en">English</Select.Option>
          <Select.Option value="th">ภาษาไทย</Select.Option>
        </Select>
        <span className="welcome-text">
          {t('header.welcome')},<strong>{user.isadmin === 2 ? t('header.superAdmin') : user.isadmin === 1 ? t('header.admin') : t('header.user')}</strong> {user.name}
        </span>
        {loginIp && (
          <span style={{ fontSize: 12, color: '#888', marginRight: 12 }}>
            IP: {loginIp}
          </span>
        )}
        <button className="logout-btn" onClick={handleLogout}>{t('header.logout')}</button>
      </div>
    </div>
  );
};

export default Header;
